// import { faSpinner } from '@fortawesome/free-solid-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import React, { useEffect, useRef, useState } from 'react'
// import { Check2Circle, CheckSquare, Pencil, PlusCircle, Square } from 'react-bootstrap-icons'
// import Questionnaire from '../../../../../libs/api/services/Questionnaire'
// import QBuilderGenerics from '../QBuilderGenerics'
// import QBuilderComponentOptions from './QBuilderComponentOptions'
// import QBuilderFieldLink from './QBuilderFieldLink'
// import QBuilderComponentSingleSelctItem from './widgets/QBuilderComponentSingleSelctItem'
// import LabelsOptions from './widgets/components/LabelsOptions'

import { useCallback, useContext, useEffect, useState } from 'react';
import { Check2Circle, CheckSquare, Square } from 'react-bootstrap-icons';
import QuestionnaireBuilderContext from '../QuestionnaireBuilderProvider';
import { AdminEditText, AdminLayoutWrapper, AdminOptions, EditPencilWrapper } from './QBuilderComponentMultiSelect';
import QBuilderFieldLink from './QBuilderFieldLink';


export default function QBuilderComponentSingleSelect({ Component,
    accessTypes = [],
    onAction,
    idx,
    edit,
    defaultMode,
    SectionComponents,
    values,
}) {
    const { SetComponentValue, GetComponentValues, SetResponse, ComponentAnswers } = useContext(QuestionnaireBuilderContext);
    const [mode, setMode] = useState(edit ? '' : '');
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(true);

    // Load options and set active state
    useEffect(() => {
        const val = GetComponentValues(Component.id);
        if (Component && val && val.Options) {
            let opts = JSON.parse(val.Options);
            if (ComponentAnswers[Component.id]) {
                let _opt
                try {
                    _opt = JSON.parse(ComponentAnswers[Component.id])
                } catch (e) {
                    console.warn('Error parsing ComponentAnswers (v1 format):', e, ComponentAnswers[Component.id])
                    // Fallback to v1 format
                    _opt = { options: [{ option: ComponentAnswers[Component.id], active: true }] }
                }
                var opt = options.find(a => a.option === _opt.option)
                if (opt) options = options.map(option => { return { ...option, active: option.option === opt.option } })
            }
            setOptions(opts);
        }
        setLoading(false);
    }, [Component, ComponentAnswers, GetComponentValues])

    // Set property helper
    const _setProperty = useCallback((prop, value) => {
        SetComponentValue(Component, prop, value);
    }, [Component, SetComponentValue])

    // Reset mode if defaultMode changes
    useEffect(() => {
        if (defaultMode === 'Overview') setMode('');
    }, [defaultMode])

    // Handle option selection
    const handleOptionSelected = useCallback(i => {
        let _options = options;
        let _option = _options[i];
        if (ComponentAnswers[Component.id]) {
            const _opt = JSON.parse(ComponentAnswers[Component.id]);
            if (_opt && _opt.option === _option.option) {
                _option = {};
            }
        }
        setOptions([..._options]);
        SetResponse(Component, JSON.stringify(_option), true);
    }, [options, Component, ComponentAnswers, SetResponse])

    if (loading) return <div>Loading</div>

    const displayAs = GetComponentValues(Component.id)["displayAs"]
    const isEditable = accessTypes.includes('Edit') || accessTypes.includes('Admin')
    const isRequired = GetComponentValues(Component.id)["Required"] && JSON.parse(GetComponentValues(Component.id)["Required"])
    const question = GetComponentValues(Component.id)["Question"]

    return (
        <CommonLayoutWrapper
            OnEdit={() => setMode('Edit Text')}
            edit={edit}
            mode={mode}
            AdminMode={
                <AdminLayoutWrapper
                    Component={Component}
                    mode={mode}
                    setMode={setMode}
                    Tabs={{
                        "Edit Text": {
                            mode: "Field Name",
                            component: <AdminEditText _setProperty={_setProperty} Component={Component} />
                        },
                        "Options": {
                            mode: "Field Options",
                            component: <AdminOptions options={options} setOptions={setOptions} _setProperty={_setProperty} SectionComponents={SectionComponents} values={values} />
                        },
                        "Link": {
                            mode: "Link Field",
                            component: <QBuilderFieldLink ComponentId={Component.id} />
                        },
                        "Style": {
                            mode: "Style",
                            component: <AdminStyle Component={Component} />
                        },
                    }}
                />
            }
            NormalMode={
                <>
                    <div className='d-flex justify-content-between'>
                        <label>{question}<b className='text-secondary'><small>{isRequired ? "*" : ''}</small></b></label>
                    </div>
                    <div>
                        {isEditable ? (
                            displayAs === 'Buttons' ? (
                                <div className='d-flex flex-column'>
                                    {options.map((option, i) => (
                                        <div
                                            key={option.option}
                                            onClick={() => handleOptionSelected(i)}
                                            className={`btn text-light ${option.active ? 'shadow bg-secondary-container' : 'bg-secondary-container opacity-75'}`}
                                        >
                                            {option.active && <Check2Circle />} {option.option}
                                        </div>
                                    ))}
                                </div>
                            ) : displayAs === 'Dropdown' ? (
                                <select
                                    onChange={e => handleOptionSelected(Number(e.target.value))}
                                    className='m-2 form-control'
                                    value={options.findIndex(option => option.active)}
                                >
                                    {options.map((option, i) => (
                                        <option
                                            key={option.option}
                                            className={option.alert ? 'text-danger' : ''}
                                            value={i}
                                        >
                                            {option.option}
                                        </option>
                                    ))}
                                </select>
                            ) : (
                                <div>
                                    {options.map((option, i) => (
                                        <div
                                            key={option.option}
                                            className={`m-2 ${option.alert ? 'text-danger' : ''}`}
                                            onClick={() => handleOptionSelected(i)}
                                        >
                                            {option.active ? (
                                                <div><CheckSquare className='me-2' />{option.option}</div>
                                            ) : (
                                                <div className=''><Square className='me-2' />{option.option}</div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )
                        ) : (
                            <div>
                                {options.map((option, i) => (
                                    option.active ? (
                                        <div key={option.option}>
                                            <CheckSquare className={`me-2 ${option.alert ? 'text-danger' : ''}`} />
                                            {option.option}
                                        </div>
                                    ) : (
                                        <div key={option.option} className='opacity-25'>
                                            <Square className='me-2' />
                                            {option.option}
                                        </div>
                                    )
                                ))}
                            </div>
                        )}
                    </div>
                </>
            }
        />
    );
}

export const CommonLayoutWrapper = ({ mode, AdminMode, NormalMode, edit, OnEdit, accessTypes }) => {
    return (
        <>
            {mode !== '' && AdminMode}
            <div className={`text-start ${mode !== '' ? 'bg-primary-container opacity-75 shadow' : ''}`}>
                <EditPencilWrapper isEdit={edit} onClick={OnEdit} />
                {NormalMode}
            </div>
        </>
    )
}

// export const EditPencilWrapper = ({ isEdit, onClick }) => isEdit && <Pencil className='me-2' onClick={(e) => onClick()} />

// export const AdminLayoutWrapper = ({ Component, mode, setMode, Tabs }) =>
//     <div style={{ cursor: 'pointer' }} className={'bg-light w-50 shadow rounded text-start p-2 position-fixed '.concat(' slide-in')}>
//         <QBuilderComponentOptions Component={Component} onClose={() => setMode('')} />
//         <div className='d-flex rounded bg-primary-container m-2'>
//             {Object.keys(Tabs).map(tab => <div key={tab} className={`p-2 ${mode === tab ? 'active' : ''}`} onClick={() => setMode(tab)}>{Tabs[tab].mode}</div>)}
//         </div>
//         {Object.keys(Tabs).includes(mode) && Tabs[mode].component}
//     </div>

// export const AdminEditText = ({ Component }) => {
//     const { ComponentValues, SetComponentValue } = useContext(QuestionnaireBuilderContext)
//     const _handleSetFieldName = (t) =>
//         SetComponentValue(Component, "Question", t)

//     const _handleSetRequired = () => {
//         SetComponentValue(Component, "Required",
//             ComponentValues[Component.id]["Required"] ?
//                 JSON.stringify(!JSON.parse(ComponentValues[Component.id]["Required"]))
//                 : "true"
//         )
//     }

//     return (
//         <div style={{ cursor: 'pointer' }} className='bg-light rounded text-start p-2 opacity-75'>
//             <div className='text-center'>
//                 <div className='d-flex justify-content-between'>
//                     <b>Enter a name for the field</b>
//                 </div>
//                 <input
//                     onChange={(e) => _handleSetFieldName(e.target.value)}
//                     defaultValue={ComponentValues[Component.id]["Question"]}
//                     className='form-control form-control-sm' placeholder='Field Name' />
//                 <div className='d-flex justify-content-between'>
//                     <div>
//                         <div>
//                             <b>Is this field required?</b>
//                         </div>
//                         <div onClick={(e) => _handleSetRequired()}>
//                             {ComponentValues[Component.id]["Required"] && JSON.parse(ComponentValues[Component.id]["Required"]) ? <CheckSquare size={20} className='me-1' /> : <Square size={20} className='me-1' />}
//                             Field is required
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

const AdminStyle = ({ Component }) => {
    const { SetComponentValue, GetComponentValues } = useContext(QuestionnaireBuilderContext);
    const displayAs = GetComponentValues(Component.id)["displayAs"];

    return (
        <div>
            <div className='row'>
                <div className='col-12'>
                    <label><b>Display options as</b></label>
                    <div onClick={() => SetComponentValue(Component, 'displayAs', 'Dropdown')}                    >
                        {displayAs === 'Dropdown' ? <CheckSquare className='me-2' /> : <Square className='me-2' />}
                        Drop Down
                    </div>
                    <div className='d-flex flex-column ' onClick={() => SetComponentValue(Component, 'displayAs', 'Buttons')}                            >
                        {displayAs === 'Buttons' ? <CheckSquare className='me-2 grow' /> : <Square className='me-2 grow' />}
                        Buttons
                    </div>
                    <div onClick={() => SetComponentValue(Component, 'displayAs', 'Checkbox')}                    >
                        {(displayAs === '' || displayAs === 'Checkbox') ? <CheckSquare className='me-2' /> : <Square className='me-2' />}
                        Check Box List
                    </div>
                </div>
            </div>
        </div>
    )
}